export const FLOAT = 'float';
export const IRON_FREE = 'iron-free';
export const OPTIWHITE = 'optiwhite';

export default [FLOAT, IRON_FREE, OPTIWHITE];
